import { useEffect, useMemo, useState } from 'react';
import TechnicianSortableAttributes from '@enums/sortable-attributes/technician-sortable-attributes.enum';
import SubcontractorSortableAttributes from '@enums/sortable-attributes/subcontractor-sortable-attributes.enum';
import useGetTechnicians from '@hooks/requests/technicians.get.hook';
import useGetSubcontractors from '@hooks/requests/subcontractors.get.hook';
import { AssigneeType } from '@enums/assignee-type.enum';
const useGetAssignees = (params) => {
    const [assignees, setAssignees] = useState();
    const [loading, setLoading] = useState(true);
    const [error] = useState();
    let teamIdsArray;
    if (params.teamId) {
        teamIdsArray = Array.isArray(params.teamId) ? params.teamId : [params.teamId];
    }
    let territoryIdsArray;
    if (params.territoryIds !== undefined && params.territoryIds !== '' && params.territoryIds !== null) {
        territoryIdsArray = Array.isArray(params.territoryIds) ? params.territoryIds : [params.territoryIds];
        if (territoryIdsArray.length === 0)
            territoryIdsArray = undefined;
    }
    const { techniciansQuery, subcontractorsQuery } = useMemo(() => {
        const tQuery = {
            select: 'all',
            filter: Object.assign({ techTeamIds: teamIdsArray }, (territoryIdsArray ? { territoryIds: territoryIdsArray } : {})),
            sort: {
                attribute: TechnicianSortableAttributes.NAME,
                direction: 'asc'
            }
        };
        const sQuery = {
            select: 'all',
            filter: {
                techTeamIds: teamIdsArray
            },
            sort: {
                attribute: SubcontractorSortableAttributes.NAME,
                direction: 'asc'
            }
        };
        return { techniciansQuery: tQuery, subcontractorsQuery: sQuery };
    }, [params.teamId, params.territoryIds]);
    const { data: techniciansList, loading: techniciansLoading } = useGetTechnicians(techniciansQuery);
    const { data: subcontractorsList, loading: subcontractorsLoading } = useGetSubcontractors(subcontractorsQuery);
    useEffect(() => {
        // Wait until both queries complete to set assignee variable
        if (!techniciansLoading && !subcontractorsLoading) {
            const processedTechs = techniciansList.map((tech) => ({
                type: AssigneeType.TECHNICIAN,
                key: `${AssigneeType.TECHNICIAN}-${tech.id}`,
                info: tech
            }));
            // When territory filter is active, hide subcontractors — they are not
            // territory-scoped and would otherwise remain as unfiltered swimlanes.
            const processedSubs = territoryIdsArray
                ? []
                : subcontractorsList.map((sub) => ({
                    type: AssigneeType.SUBCONTRACTOR,
                    key: `${AssigneeType.SUBCONTRACTOR}-${sub.id}`,
                    info: sub
                }));
            setAssignees([...processedTechs, ...processedSubs]);
        }
    }, [techniciansList, subcontractorsList, techniciansLoading, subcontractorsLoading, territoryIdsArray]);
    useEffect(() => {
        setLoading(techniciansLoading || subcontractorsLoading);
    }, [techniciansLoading, subcontractorsLoading]);
    return { assignees, loading, error };
};
export default useGetAssignees;
